import { type CardDetailsGroup, NotRequestedCardStatus } from '../EmployeeDetails/types';
import { FlexflowCardStatus } from '../types';

export const getPhysicalCardStatus = (data?: CardDetailsGroup) => {
  if (!data?.physicalCard?.status || data?.physicalCard?.status === FlexflowCardStatus.TERMINATED) {
    return NotRequestedCardStatus.NOT_REQUESTED;
  }

  if (data?.status !== FlexflowCardStatus.ACTIVE) {
    return data?.status;
  }

  return data.physicalCard.status;
};
